/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/CreditCard.yaml

import { ScanbotCreditCardImpl } from './impl';
import type { ImageInput, ResultWrapper } from './types/base/customTypes';
import type {
  CreditCardScannerConfiguration,
  CreditCardScanningResult,
} from './types/core/credit_card/CreditCardTypes';
import type { CreditCardScannerScreenConfiguration } from './types/core/ui_v2/credit_card/CreditCardScannerScreenConfiguration';
import type { CreditCardScannerUiResult } from './types/core/ui_v2/credit_card/CreditCardScannerUiResult';

/**
 * Entry point for all Credit Card scanning features.
 */
export const ScanbotCreditCard = {
  /**
   * Opens the Ready-To-Use UI Credit Card scanner with the desired configuration.
   * @param {CreditCardScannerScreenConfiguration} configuration - The Credit Card scanner configuration to be used for scanning.
   * @returns {Promise<ResultWrapper<CreditCardScannerUiResult>>} - The result of the Credit Card scanning operation.
   */
  async startScanner(
    configuration: CreditCardScannerScreenConfiguration,
  ): Promise<ResultWrapper<CreditCardScannerUiResult>> {
    return ScanbotCreditCardImpl.startScanner(configuration);
  },
  /**
   * Scans Credit Card from a given image with the desired configuration.
   * @param {ImageInput} params.image - The image to be used for scanning.
   * @param {CreditCardScannerConfiguration} params.configuration - The Credit Card scanner configuration to be used for scanning.
   * @returns {Promise<CreditCardScanningResult>} - The result of the Credit Card scanning operation.
   */
  async scanFromImage(params: {
    image: ImageInput;
    configuration: CreditCardScannerConfiguration;
  }): Promise<CreditCardScanningResult> {
    return ScanbotCreditCardImpl.scanFromImage(params);
  },
};
